import React from 'react';

import {Banner, Button} from '@albert-io/atomic';
import LoadingIndicator from 'generic/LoadingIndicator.react';

import {ClassSettingsForm} from './ClassSettingsForm';
import {useClassSettings} from './useClassSettings';

interface Props {
  classroomId: string;
}

// v2 Settings tab: owns the classroom subscription + mutations (useClassSettings) and renders the
// RHF - Replaces the legacy Flux-store TeacherClassroomSettings.
export const Settings = ({classroomId}: Props) => {
  const settings = useClassSettings(classroomId);

  if (!settings.isReady) {
    return <LoadingIndicator />;
  }

  if (settings.hasError || typeof settings.classroom?.getId !== 'function') {
    return (
      <div className='pt-x4'>
        <Banner type='negative'>
          <Banner.Icon icon='exclamation' />
          <div className='flex flex-col items-start gap-x1'>
            <span>We couldn’t load this class’s settings.</span>
            <Button variant='outlined' color='secondary' onClick={settings.reload}>
              Try again
            </Button>
          </div>
        </Banner>
      </div>
    );
  }

  return (
    <div className='pt-x4'>
      <ClassSettingsForm settings={settings} />
    </div>
  );
};
